export const LOCALES: Array<{ id: UserLocale; name: string }> = [
  {
    id: 'en',
    name: 'English',
  },
  {
    id: 'es',
    name: 'Español',
  },
  {
    id: 'pt',
    name: 'Português',
  },
];

export const LOCALES_WITH_ALL = [
  {
    id: 'all',
    name: 'All',
  },
  ...LOCALES,
];
